import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { SharedModule } from './shared/shared.module';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    SharedModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {

  title = 'Journey';

  constructor(
    translate: TranslateService,
    titleService: Title,
    private router: Router
  ) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use(environment.defaultLanguage ?? 'nl');

    titleService.setTitle(environment.tabTitle ?? this.title);

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Save the current route to sessionStorage
        sessionStorage.setItem('lastRoute', event.urlAfterRedirects);
      }
    });
  }

}